let nextTodoId = 0
export const addTodo = text => {
  return {
    type: 'ADD_TODO',
    id: nextTodoId++,
    text
  }
}

export const setVisibilityFilter = filter => {
  return {
    type: 'SET_VISIBILITY_FILTER',
    filter
  }
}

export const homeUpdateSearchKey = key => {
  return {
    type: 'HOME_UPDATE_SEARCH_KEY',
    key
  }
}

export const updateCategoryId = id => {
  return {
    type: 'UPDATE_CATEGORY_ID',
    id
  }
}

export const setUser = user => {
  return {
    type: 'SET_USER',
    user
  }
}

// 保存分类
export const setCategories = categories => {
  return {
    type: 'SET_CATEGORIES',
    categories
  }
}

export const setRoute = route => {
  return {
    type: 'SET_ROUTE',
    route
  }
}